import { motion } from 'framer-motion';
import CompanyLogosSection from '@/features/courses/components/CompanyLogosSection';
import GrowthPlaybooksBanner from '@/features/courses/components/GrowthPlaybooksBanner';

const ProvenPlaybooksShowcase = () => {
  return (
    <motion.div
      className="mb-12 min-w-0 max-w-full md:mb-16 space-y-0"
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
    >
      <div className="mb-4 sm:mb-6">
        <CompanyLogosSection />
      </div>

      <GrowthPlaybooksBanner />
    </motion.div>
  );
};

export default ProvenPlaybooksShowcase;
